import React from 'react';

export default function ReviewList(props) {
  const surveyQuestions = props.surveyQuestions;
  const selectedAnswers = props.selectedAnswers;
  const optionArray = props.optionArray
  return (
    <div className="col-md-12">
      {surveyQuestions.map((qs, index) => (
        <div key={index}>
          {selectedAnswers[qs.questionkey] !== null ? (
            <>
            {qs.questionkey !== 'review'?(
              <div className="survey-questions-div question-review">
                <p className="survey-questions-tag">{qs.questionno.toString()
                      .padStart(2, "0")}.</p>
                <p className="survey-questions">
                  {qs.question}
                </p>
              </div>
              ):(null)}
              <div className='survey-answer-div-review'>
                {selectedAnswers[qs.questionkey].map((inner, idx) => (
                  <li key={idx}>
                    {optionArray.data.masterdata[qs.questionkey].TYPE === 'discrete' || optionArray.data.masterdata[qs.questionkey].TYPE === 'radio' || optionArray.data.masterdata[qs.questionkey].TYPE === 'checkbox' ? (
                      <>
                        {optionArray.data.masterdata[qs.questionkey].OPTIONS.filter(e => e.PK_ID === inner).map(filteredName => (
                          <>
                            {filteredName.VALUE}
                          </>
                        ))}
                      </>
                    ) : (
                      <>{inner}</>
                    )}
                  </li>
                ))}
              </div>
              {/* If the question key is satscore, then display the sub questions and options */}
              {qs.questionkey === 'satscore' && selectedAnswers["satscore"][0] === 1 ? (
                <>
                  {qs.sub.map((sub, id) => (
                    <>
                      <div className="survey-questions-div question-review sub-question">
                        <p className="survey-questions-tag">Q.</p>
                        <p className="survey-questions">
                          {sub.question}
                        </p>
                      </div>
                      <div className='survey-answer-div-review'>
                        {selectedAnswers[sub.questionkey].map((ins, x) => (
                          <li key={x}>
                            {optionArray.data.masterdata[qs.questionkey].suboptions[sub.questionkey].TYPE === 'discrete' || optionArray.data.masterdata[qs.questionkey].suboptions[sub.questionkey].TYPE === 'radio' || optionArray.data.masterdata[qs.questionkey].suboptions[sub.questionkey].TYPE === 'checkbox' ? (
                              <>
                                {optionArray.data.masterdata[qs.questionkey].suboptions[sub.questionkey].OPTIONS.filter(i => i.PK_ID === ins).map(name => (
                                  <>
                                    {name.VALUE}
                                  </>
                                ))}
                              </>
                            ) : (
                              <>{ins}</>
                            )}
                          </li>
                        ))}
                      </div>
                    </>
                  ))}
                </>
              ) : (null)}
              {/* If the question key is actscore, then display the sub questions and options */}
              {qs.questionkey === 'actscore' && selectedAnswers["actscore"][0] === 1 ? (
                <>
                  {qs.sub.map((sub, id) => (
                    <>
                      <div className="survey-questions-div question-review sub-question">
                        <p className="survey-questions-tag">Q.</p>
                        <p className="survey-questions">
                          {sub.question}
                        </p>
                      </div>
                      <div className='survey-answer-div-review'>
                        {selectedAnswers[sub.questionkey].map((ins, x) => (
                          <li key={x}>
                            {optionArray.data.masterdata[qs.questionkey].suboptions[sub.questionkey].TYPE === 'discrete' || optionArray.data.masterdata[qs.questionkey].suboptions[sub.questionkey].TYPE === 'radio' || optionArray.data.masterdata[qs.questionkey].suboptions[sub.questionkey].TYPE === 'checkbox' ? (
                              <>
                                {optionArray.data.masterdata[qs.questionkey].suboptions[sub.questionkey].OPTIONS.filter(i => i.PK_ID === ins).map(name => (
                                  <>
                                    {name.VALUE}
                                  </>
                                ))}
                              </>
                            ) : (
                              <>{ins}</>
                            )}
                          </li>
                        ))}
                      </div>
                    </>
                  ))}
                </>
              ) : (null)}
              {/* If the question key is apib, then display the sub questions and options */}
              {qs.questionkey === 'apibscore' && selectedAnswers["apibscore"][0] === 1 ? (
                <>
                  {qs.sub.map((sub, id) => (
                    <>
                      <div className="survey-questions-div question-review sub-question" key={id}>
                        <p className="survey-questions-tag">Q.</p>
                        <p className="survey-questions">
                          {sub.question}
                        </p>
                      </div>
                      <div className='survey-answer-div-review'>
                        {selectedAnswers[sub.questionkey].map((ins, x) => (
                          <li key={x}>
                            {optionArray.data.masterdata[qs.questionkey].suboptions[sub.questionkey].TYPE === 'discrete' || optionArray.data.masterdata[qs.questionkey].suboptions[sub.questionkey].TYPE === 'radio' || optionArray.data.masterdata[qs.questionkey].suboptions[sub.questionkey].TYPE === 'checkbox' ? (
                              <>
                                {optionArray.data.masterdata[qs.questionkey].suboptions[sub.questionkey].OPTIONS.filter(i => i.PK_ID === ins).map(name => (
                                  <>
                                    {name.VALUE}
                                  </>
                                ))}
                              </>
                            ) : (
                              <>{ins}</>
                            )}
                          </li>
                        ))}
                      </div>
                    </>
                  ))}
                </>
              ) : (null)}
              {/* If the question key is writting ability, then display the sub questions and options */}
              {qs.questionkey === 'writtingskills' ? (
                <>
                  {qs.sub.map((sub, id) => (
                    <>
                    <div className="survey-questions-div question-review sub-question" key={id}>
                      <p className="survey-questions-tag">Q.</p>
                      <p className="survey-questions">
                        {sub.question}
                      </p>
                    </div>
                    <div className='survey-answer-div-review'>
                      {selectedAnswers[sub.questionkey].map((ins, x) => (
                        <li key={x}>
                          {optionArray.data.masterdata[qs.questionkey].suboptions[sub.questionkey].TYPE === 'discrete' || optionArray.data.masterdata[qs.questionkey].suboptions[sub.questionkey].TYPE === 'radio' || optionArray.data.masterdata[qs.questionkey].suboptions[sub.questionkey].TYPE === 'checkbox' ? (
                            <>
                              {optionArray.data.masterdata[qs.questionkey].suboptions[sub.questionkey].OPTIONS.filter(i => i.PK_ID === ins).map(name => (
                                <>
                                  {name.VALUE}
                                </>
                              ))}
                            </>
                          ) : (
                            <>{ins}</>
                          )}
                        </li>
                      ))}
                    </div>
                  </>
                  ))}
                </>
              ) : (null)}
              {/* If the question key is research, then display the sub questions and options */}
              {qs.questionkey === 'research' && selectedAnswers["research"][0] === 1 ? (
                <>
                  {qs.sub.map((sub, id) => (
                    <>
                      <div className='survey-answer-div-review'>
                        {selectedAnswers[sub.questionkey].map((ins, x) => (
                          <li key={x}>
                            {optionArray.data.masterdata[qs.questionkey].suboptions[sub.questionkey].TYPE === 'discrete' || optionArray.data.masterdata[qs.questionkey].suboptions[sub.questionkey].TYPE === 'radio' || optionArray.data.masterdata[qs.questionkey].suboptions[sub.questionkey].TYPE === 'checkbox' ? (
                              <>
                                {optionArray.data.masterdata[qs.questionkey].suboptions[sub.questionkey].OPTIONS.filter(i => i.PK_ID === ins).map(name => (
                                  <>
                                    {name.VALUE}
                                  </>
                                ))}
                              </>
                            ) : (
                              <>{ins}</>
                            )}
                          </li>
                        ))}
                      </div>
                    </>
                  ))}
                </>
              ) : (null)}
            </>
          ) : (null)}
        </div>
      ))}
    </div>
  );
}